import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { Checkbox } from '../../../components/ui/checkbox';
import { useColumnasCfg } from './AtencionColumnasContext';

const porDefecto = (catalogo) => Object.fromEntries(Object.entries(catalogo).map(([h, c]) =>
  [h, c.columnas.filter((x) => !x.fija && x.defecto).map((x) => x.key)]));

// Columnas del Excel, por hoja: las elige un administrador y valen para todos.
export const useColumnasExport = (catalogo) => {
  const { cfg, puede, guardar } = useColumnasCfg();
  const sel = { ...porDefecto(catalogo), ...cfg.export };
  return { sel, puede, guardar: (v) => guardar({ export: v }), reset: () => guardar({ export: {} }) };
};

const Hoja = ({ hoja, info, elegidas, onToggle }) => {
  const [abierta, setAbierta] = useState(false);
  const libres = info.columnas.filter((c) => !c.fija);
  return (
    <div className="rounded-lg border border-slate-200" data-testid={`export-hoja-${hoja}`}>
      <button type="button" onClick={() => setAbierta((a) => !a)} className="flex w-full items-center justify-between px-3 py-2 text-sm"
        data-testid={`export-hoja-${hoja}-toggle`}>
        <span className="font-medium text-slate-700">{info.hoja}</span>
        <span className="flex items-center gap-2 text-xs text-slate-500">
          {elegidas.length + 1} de {info.columnas.length} columnas
          <ChevronDown className={`h-4 w-4 transition-transform ${abierta ? 'rotate-180' : ''}`} />
        </span>
      </button>
      {abierta && (
        <div className="grid grid-cols-2 gap-x-3 gap-y-1.5 border-t border-slate-100 px-3 py-2">
          {info.columnas.map((c) => (
            <label key={c.key} className={`flex items-center gap-2 text-xs ${c.fija ? 'text-slate-400' : 'cursor-pointer text-slate-700'}`}>
              <Checkbox checked={c.fija || elegidas.includes(c.key)} disabled={c.fija || (elegidas.length === 1 && elegidas.includes(c.key) && libres.length > 1)}
                onCheckedChange={() => onToggle(c.key)} data-testid={`export-col-${hoja}-${c.key}`} />
              {c.label}{c.fija ? ' (siempre)' : ''}
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

// Parte C + pedido del usuario: elegir qué columnas se exportan en cada hoja del Excel.
export const AtencionColumnasExport = ({ catalogo, estado }) => {
  const toggle = (hoja, key) => {
    const actual = estado.sel[hoja] || [];
    estado.guardar({ ...estado.sel, [hoja]: actual.includes(key) ? actual.filter((k) => k !== key) : [...actual, key] });
  };
  return (
    <div className="space-y-2" data-testid="atencion-export-columnas">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-slate-700">Columnas a exportar</p>
          <p className="text-xs text-slate-400">Lo que elijas se guarda para todos los usuarios.</p>
        </div>
        <button type="button" onClick={estado.reset} className="text-xs text-sky-700 hover:underline" data-testid="atencion-export-columnas-defecto">Volver a las de siempre</button>
      </div>
      <div className="max-h-64 space-y-2 overflow-auto pr-1">
        {Object.entries(catalogo).map(([hoja, info]) => (
          <Hoja key={hoja} hoja={hoja} info={info} elegidas={estado.sel[hoja] || []} onToggle={(k) => toggle(hoja, k)} />
        ))}
      </div>
    </div>
  );
};
